import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@shadcn-in-nx/ui/dialog";
import { Button } from "@shadcn-in-nx/ui/button";
import { Crown, Check, ArrowRight } from "lucide-react";

export default function HumanSupportPaywall({ isOpen, onClose }) {
    const navigate = useNavigate();

    const handleUpgrade = () => {
        onClose();
        navigate("/billing#support");
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Crown className="h-5 w-5 text-yellow-500" />
                        Upgrade to Human Support
                    </DialogTitle>
                    <DialogDescription>
                        You've used your 2 free tickets
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4 py-4">
                    <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-lg p-4 border border-yellow-200">
                        <h4 className="font-semibold text-gray-900 mb-2">
                            Unlock Unlimited Human Support
                        </h4>
                        <ul className="space-y-2">
                            <li className="flex items-center gap-2 text-sm text-gray-700">
                                <Check className="h-4 w-4 text-green-600" />
                                Unlimited support tickets
                            </li>
                            <li className="flex items-center gap-2 text-sm text-gray-700">
                                <Check className="h-4 w-4 text-green-600" />
                                Priority response time
                            </li>
                            <li className="flex items-center gap-2 text-sm text-gray-700">
                                <Check className="h-4 w-4 text-green-600" />
                                Dedicated support expert
                            </li>
                            <li className="flex items-center gap-2 text-sm text-gray-700">
                                <Check className="h-4 w-4 text-green-600" />
                                Screen share sessions
                            </li>
                        </ul>
                    </div>

                    <p className="text-xs text-gray-500 text-center">
                        Choose a plan that fits your needs
                    </p>
                </div>

                <div className="flex gap-2">
                    <Button variant="outline" onClick={onClose} className="flex-1">
                        Maybe Later
                    </Button>
                    <Button
                        onClick={handleUpgrade}
                        className="flex-1 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600"
                    >
                        View Plans
                        <ArrowRight className="h-4 w-4 ml-2" />
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
